<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<style scoped>
@media
screen and (max-width: 375px) and (min-width: 374px),
screen and (max-width: 414px) and (min-width: 413px),
screen and (max-width: 640px) and (min-width: 600px),
screen and (min-width: 300px) and (max-width:400px)
{
  .effect-lists{
    justify-content: flex-start!important;
  }
}
@media screen and (max-width: 640px){
  .table{
    width: 90% !important;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
<style scoped lang="scss">
.cons{
  display: none;
}
.effect-lists{
  //display: block!important;
  justify-content: space-between;
  flex-wrap:wrap;
  overflow: auto;
}
.effect-lists li{
  margin-right: 30px;
  float: left;
  width: 18%;
  text-align: center;
  margin-bottom: 30px;
}
.effect-lists li:nth-last-of-type(1),.effect-lists li:nth-last-of-type(2),.effect-lists li:nth-last-of-type(3),.effect-lists li:nth-last-of-type(4),.effect-lists li:nth-last-of-type(5){
  margin-bottom: 0;
}
.effect-lists li:nth-child(5n){
  margin-right: 0;
}
</style>
<template>
  <div class="wrap wrap-tec">
    <div class="banner">
      <img src="@/assets/img/产品及服务/常规分子项目/banner1.jpg" class="img-fluid">
      <div class="info">
<!--        <div class="container">-->
<!--          <h1>DNA提取</h1>-->
<!--          <h2 class="mt10">DNA extraction</h2>-->
<!--        </div>-->
      </div>
    </div>
    <section class="container">
      <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-bottom: 20px;">
        <bread></bread>
      </div>
      <p class="desc">擎科生物DNA提取服务样品类型：植物（叶、茎、皮、干燥组织）、动物、人（血液、唾液、组织、石蜡、毛囊）根据不同样本类型，选取不同的试剂盒，如：植物多糖多酚样本、石蜡样本、毛囊样本，均采用不同的试剂盒和实验方案；若样本量较多，采用自动化提取仪提取DNA。</p>
      <div class="c-title">服务流程<small>Service Process</small></div>
      <el-row type="flex" align="bottom">
        <el-col :span="12">
          <img src="@/assets/images/dna_1.png" class="img-fluid">
        </el-col>
        <el-col :span="12">
          <div class="required" style="height:280px;">
            <p class="mb20">1、客户提供提取样本；</p>
            <p>2、提取基因组DNA并进行质检。</p>
          </div>
        </el-col>
      </el-row>
      <div class="c-title">结果交付<small>Delivery Of Results</small></div>
      <el-row type="flex" align="bottom">
        <el-col :span="12" style="z-index: 2">
          <div class="required left" style="height:280px;">
            <p class="mb20">1、提供纸质版和电子版样本信息表，提供电泳胶图，注明浓度、
            体积情况；</p>
            <p class="mb20">2、提供提取的DNA样品，存于离心管或96孔板中；</p>
            <p class="mb20">3、提取样品浓度≥ 30 ng/μL、30-50 μL；特殊样本除外；</p>
            <p class="mb20">4、周期为3-5个工作日。</p>
          </div>
        </el-col>
        <el-col :span="12">
          <img src="@/assets/images/dna_2.png" class="img-fluid">
        </el-col>
      </el-row>
      <div class="c-title">案例<small>Case</small></div>
      <div class="tc"><img src="@/assets/images/dna_3.png"></div>
      <el-row :gutter="40" class="mt30">
        <el-col :span="12">
          <table class="table">
            <tr>
              <th>项目内容</th>
              <th>样品板号</th>
              <th>样品孔号</th>
              <th>DNA浓度
                （ng/ul）</th>
            </tr>
            <tr>
              <td>183113278</td>
              <td>TQ-1</td>
              <td>A01</td>
              <td>35</td>
            </tr>
            <tr>
              <td>183113245</td>
              <td>TQ-1</td>
              <td>B01</td>
              <td>71</td>
            </tr>
            <tr>
              <td>183113348</td>
              <td>TQ-1</td>
              <td>C01</td>
              <td>31</td>
            </tr>
            <tr>
              <td>183113251</td>
              <td>TQ-1</td>
              <td>D01</td>
              <td>32</td>
            </tr>
            <tr>
              <td>183113240</td>
              <td>TQ-1</td>
              <td>E01</td>
              <td>65</td>
            </tr>
            <tr>
              <td>183113340</td>
              <td>TQ-1</td>
              <td>F01</td>
              <td>45</td>
            </tr>
          </table>
        </el-col>
        <el-col :span="12">
          <table class="table">
            <tr>
              <th>项目内容</th>
              <th>样品板号</th>
              <th>样品孔号</th>
              <th>DNA浓度
                （ng/ul）</th>
            </tr>
            <tr>
              <td>183113324</td>
              <td>TQ-1</td>
              <td>G01</td>
              <td>46</td>
            </tr>
            <tr>
              <td>183113230</td>
              <td>TQ-1</td>
              <td>H01</td>
              <td>68</td>
            </tr>
            <tr>
              <td>183113242</td>
              <td>TQ-1</td>
              <td>A02</td>
              <td>43</td>
            </tr>
            <tr>
              <td>182492286</td>
              <td>TQ-1</td>
              <td>B02</td>
              <td>69</td>
            </tr>
            <tr>
              <td>183113289</td>
              <td>TQ-1</td>
              <td>C02</td>
              <td>45</td>
            </tr>
            <tr>
              <td>183113246</td>
              <td>TQ-1</td>
              <td>D02</td>
              <td>54</td>
            </tr>
          </table>
        </el-col>
      </el-row>
      <p class="mt20">注：以上为部分数据，详情请联系客服</p>
      <div class="c-title">相关服务<small>Related services</small></div>
<!--      <ul class="services">-->
<!--        <li><img src="@/assets/images/dna_icon_1.png">PCR扩增 </li>-->
<!--        <li><img src="@/assets/images/dna_icon_2.png">载体构建 </li>-->
<!--        <li><img src="@/assets/images/dna_icon_3.png">SNP检测 </li>-->
<!--        <li><img src="@/assets/images/dna_icon_4.png">Sanger测序 </li>-->
<!--        <li><img src="@/assets/images/dna_icon_5.png">引物合成 </li>-->
<!--        <li><img src="@/assets/images/dna_icon_6.png">提取+扩增+测序+数据分析 </li>-->
<!--      </ul>-->
      <div class="con">
        <ul class="effect-lists">
          <li v-for="(item, index) in types" :key="index" class="pointer" :class="{active: currentType === index}" @mouseover="currentType = index" @mouseout="currentType = -1" @click="$router.push(item.ref)">
            <img :src="`/static/img/Project_${item.img}${currentType===index ? '' : ''}.png`">
            <p style="margin-top: 10px;">{{item.name}}</p>
          </li>
        </ul>
      </div>
      <div class="cons" style="margin-top: 20px;">
        <ul class="effect-lists">
          <li v-for="(item, index) in types" :key="index" class="pointer"   @click="$router.push(item.ref)">
            <img :src="`/static/img/Project_${item.img}${currentType===index ? '' : ''}.png`" style="width: 60px;">
            <p style="margin-top: 10px;font-size:12px;">{{item.name}}</p>
          </li>
        </ul>
      </div>
    </section>
    <qk-consult type="Virus"/>
  </div>
</template>
<script>
import bread from "@/components/bread"
export default {
  components: {
    bread,
  },
  data () {
    return {
      currentType:-1,
      types: [
        {name: 'PCR扩增', img: '2', ref: '/tec/PCR'},
        {name: '提取+扩增+测序', img: '3', ref: '/products/DNA_tiqu'},
        {name: '荧光定量PCR', img: '7', ref: '/tec/qPCR'},
        {name: '菌种鉴定', img: '8', ref: '/tec/rDNA'},
      ],
    }
  },
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// src/views/tec/DNA_extraction.vue